module.exports = __webpack_public_path__ + "img/quietseas-logo-blue.81044691.png";